window.addEventListener('alpine:init', () => {
  if (window.global.registeredAlpineComponents['cart']) return;

  var { removeSectionWrapper, getDefaultAlpineMorphLifecycleHooks } = Alpine.store('utilities');

  var defaultAlpineMorphLifecycleHooks = getDefaultAlpineMorphLifecycleHooks();

  function cart(data = {}) {
    return {
      ...data,

      cartErrors: [],

      isLoadingCart: false,

      init() {
        this.onCartChangeStart = this.onCartChangeStart.bind(this);
        this.onCartChangeEnd = this.onCartChangeEnd.bind(this);
        this.onCartChangeSuccess = this.onCartChangeSuccess.bind(this);
        this.onCartChangeError = this.onCartChangeError.bind(this);

        window.addEventListener('cartchangestart', this.onCartChangeStart);
        window.addEventListener('cartchangeend', this.onCartChangeEnd);
        window.addEventListener('cartchangesuccess', this.onCartChangeSuccess);
        window.addEventListener('cartchangeerror', this.onCartChangeError);

        if (!this.$store.cart.sectionIds.includes(this.sectionId)) {
          this.$store.cart.sectionIds = [...this.$store.cart.sectionIds, this.sectionId];
        }
      },

      destroy() {
        window.removeEventListener('cartchangestart', this.onCartChangeStart);
        window.removeEventListener('cartchangeend', this.onCartChangeEnd);
        window.removeEventListener('cartchangesuccess', this.onCartChangeSuccess);
        window.removeEventListener('cartchangeerror', this.onCartChangeError);
      },

      onCartChangeStart() {
        this.isLoadingCart = true;
      },

      onCartChangeEnd() {
        this.isLoadingCart = false;
      },

      onCartChangeSuccess(event) {
        this.cartErrors = [];
        this.render(event.detail.res.sections[this.sectionId]);
      },

      onCartChangeError(event) {
        var err = event.detail.err.message || event.detail.err.name;

        try {
          err = JSON.parse(event.detail.err.message).message || JSON.parse(event.detail.err.message).errors;
        } catch {}

        if (err) {
          this.cartErrors = [err];
        }

        this.isLoadingCart = true;

        var fetchUrl = new URL(`${location.origin}${window.global.routes.root_url}`);

        fetchUrl.searchParams.set('section_id', this.sectionId);

        fetch(fetchUrl)
          .then((res) => {
            if (!res.ok) {
              throw new Error();
            }

            return res.text();
          })
          .then((res) => {
            this.render(res);
          });
      },

      render(sectionHtml) {
        var sectionInnerHtml = removeSectionWrapper(sectionHtml);

        Alpine.morph(this.$root, sectionInnerHtml, defaultAlpineMorphLifecycleHooks);
      }
    };
  };

  Alpine.data('cart', cart);

  window.global.registeredAlpineComponents['cart'] = true;
});
